import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import * as Sentry from "@sentry/react";
import { startAppVersionWatcher } from "./utils/appVersion";

window.addEventListener("vite:preloadError", (_event) => {
  console.log("vite:preloadError");
  window.location.reload();
});

startAppVersionWatcher();

const isRecoverableRemoveChildError = (value: unknown): boolean => {
  if (!(value instanceof DOMException)) return false;
  const message = value.message || "";
  return (
    message.includes("removeChild") &&
    (message.includes("not a child") ||
      message.includes("The node to be removed is not a child of this node") ||
      message.includes("不是此節點的子節點") ||
      message.includes("不是该节点的子节点"))
  );
};

// 處理瀏覽器翻譯工具造成的 DOM 操作錯誤
// 當瀏覽器翻譯工具修改 DOM 時，Radix UI 組件可能會嘗試移除已被翻譯工具修改的節點
window.addEventListener("error", (event: ErrorEvent) => {
  if (isRecoverableRemoveChildError(event.error)) {
    // 忽略瀏覽器翻譯工具造成的 DOM 操作錯誤
    event.preventDefault();
    return;
  }
});

// 捕獲未處理的 Promise rejection（Radix UI 可能使用 async 操作）
window.addEventListener(
  "unhandledrejection",
  (event: PromiseRejectionEvent) => {
    if (isRecoverableRemoveChildError(event.reason)) {
      // 忽略瀏覽器翻譯工具造成的 DOM 操作錯誤
      event.preventDefault();
      return;
    }
  },
);

Sentry.init({
  dsn:
    import.meta.env.MODE != "development"
      ? "https://4ede5672f6fb310c26944ca83506b7ad@o4507666089771008.ingest.us.sentry.io/4507666710921216"
      : "",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  environment: import.meta.env.MODE,
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [new RegExp(import.meta.env.VITE_BACKEND_ENDPOINT)],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
